export const GET_ALL_USERS = "GET_ALL_USERS";
export const REMOVE_A_USER = "REMOVE_A_USER";
export const UPDATE_A_USER = "UPDATE_A_USER";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_USERS = "START_LOADING_USERS";
export const ERROR_LOADING_USERS = "ERROR_LOADING_USERS"
export const STOP_LOADING_USERS = "STOP_LOADING_USERS";
